import type SlsTracker from "@aliyun-sls/web-track-browser";
import { getLang, languageName } from "@/utils/getLang";

const slsOpts = {
  host: "us-east-1.log.aliyuncs.com", // 例如 cn-hangzhou.log.aliyuncs.com
  project: "quan-event-tracking",
  logstore:
    process.env.NEXT_PUBLIC_ENV === "prod"
      ? "event-tracking-logstore-web"
      : "event-tracking-logstore-web-test",
  time: 10,
  count: 10,
  source: "web",
  tags: {
    env: process.env.NEXT_PUBLIC_ENV,
    version: process.env.NEXT_PUBLIC_VERSION,
  },
};

let tracker: SlsTracker | null = null;
let initializing: Promise<SlsTracker> | null = null;

export async function sendSlsEvent(
  event: Record<string, unknown>,
  immediate = false,
  pageLocale?: string
) {
  if (typeof window === "undefined") return; // 只在客户端执行

  if (!tracker) {
    initializing ??= import("@aliyun-sls/web-track-browser")
      .then(({ default: Tracker }) => new Tracker(slsOpts))
      .catch((error: unknown) => {
        initializing = null;
        throw error;
      });
    tracker = await initializing;
  }
  const lang = pageLocale ?? getLang();
  const sessionId = sessionStorage.getItem("session_id");
  console.log("lang", lang, languageName[lang]);
  const commonData = {
    UM_VersionCode: process.env.NEXT_PUBLIC_VERSION,
    UM_SystemVersion: "", //手机系统版本 拿到就报
    UM_DeviceModel: "", //手机型号 拿到就报
    UM_Channel: "H5",
    env: process.env.NEXT_PUBLIC_ENV,
    local_timestamp: new Date().getTime(),
    UM_AppLang: languageName[lang],
    UM_SessionId: sessionId,
    h5DeviceId: localStorage.getItem("deviceId"),
  };
  if (immediate) tracker.sendImmediate({ ...commonData, ...event });
  else tracker.send({ ...commonData, ...event });
}
